import ExternalAccounts from '/js/yext/externalaccounts/listingslaunch/externalaccounts';
import {ExternalAccountsContext} from '/js/yext/externalaccounts/shared/listingslaunch/externalaccountscontext';
import {LinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';
import {LinkedAccountsTable} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/linkedaccounts/linkedaccountstable';

/**
 * @dict
 * @typedef {{
 *   publisherId: number,
 *   linkedAccount: (LinkedAccount | undefined),
 *   setLinkedAccount: function(LinkedAccount=): void,
 *   canLinkOrgAccount?: boolean,
 *   isTest: boolean,
 *   skipSetup?: boolean,
 * }}
 */
export let LinkedAccountsProps;

/**
 * @param {LinkedAccountsProps} props
 */
export function LinkedAccounts({
  publisherId,
  linkedAccount,
  setLinkedAccount,
  canLinkOrgAccount=false,
  isTest,
  skipSetup=false,
}) {
  const {
    publisherIdToExternalAccount,
  } = React.useContext(ExternalAccountsContext);

  React.useEffect(() => {
    const externalAccount = publisherIdToExternalAccount.get(publisherId);
    if (externalAccount !== undefined) {
      setLinkedAccount(new LinkedAccount({
        id: externalAccount.id,
        name: externalAccount.name,
        emailAddress: externalAccount.email,
      }));
    } else {
      setLinkedAccount(undefined);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publisherIdToExternalAccount]);

  if (isTest) {
    return <LinkedAccountsTable linkedAccount={linkedAccount} setLinkedAccount={setLinkedAccount} />;
  }

  return (
    <ExternalAccounts
      publisherId={publisherId}
      canLinkOrgAccount={canLinkOrgAccount}
      skipSetup={skipSetup}
      enableCallout={false}
    />
  );
}
